module.exports = __webpack_public_path__ + "static/media/oberflex-zebranogriscendre-1200x2490.09efb289.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranogriscendre-1200x2490.jpg
// module id = 1080
// module chunks = 37